module.exports = __webpack_public_path__ + "static/szkoleniowa-1-cb82ff5669057c7a510c97ace5d1f59a.jpg";